
const digest = 'aa06b016b86936287bed76cd803937ba1ff07ed3103ce8116bd9d7e4a5050c4e';
const css = `._selectionRectangle_1g7wa_1 {
  display: flex;
  position: relative;
  border-radius: 4px;
  outline-offset: 0px;
  max-width: 100%;
}

._selectionRectangleInline_1g7wa_9 {
  display: inline-flex;
}

._selectionRectangleSelected_1g7wa_13 {
  outline: 2px solid rgb(var(--aha-editor-v2--selection-outline-color));
}

._selectionRectangleMargin_1g7wa_17 {
  outline-offset: 2px;
}

._selectionRectangleBackground_1g7wa_21 {
  background-color: var(--theme-list-item-active-background);
}

._selectionRectangleFill_1g7wa_25 {
  width: 100%;
  height: 100%;
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"selectionRectangle":"_selectionRectangle_1g7wa_1","selectionRectangleInline":"_selectionRectangleInline_1g7wa_9","selectionRectangleSelected":"_selectionRectangleSelected_1g7wa_13","selectionRectangleMargin":"_selectionRectangleMargin_1g7wa_17","selectionRectangleBackground":"_selectionRectangleBackground_1g7wa_21","selectionRectangleFill":"_selectionRectangleFill_1g7wa_25"};
export { css, digest };
  